import { useTranslation } from "react-i18next";
import PanelsLayout from "components/PanelsLayout";
import { useState } from "react";
import { useParams } from "react-router-dom";
import EmptyPanel from "components/EmptyPanel";
import { useDebounce } from "use-debounce";
import MessagesRegister from "components/Registry/MessagesRegister";
import { ItemKind } from "dto/IKindItems";
import CasesRegister from "components/Registry/CasesRegister";
import DokumentyKsiegoweRegister from "components/Registry/DokumentyKsiegoweRegister";
import ContractRegister from "components/Registry/ContractRegister";
import PIDeliverancesRegister from "components/Registry/PIDeliverancesRegister";
import TrialBalanceRegister from "components/Registry/TrialBalanceRegister";
import JournalRegister from "components/Registry/JournalRegister";
import ContractorsRegister from "components/Registry/ContractorsRegister";
import ContractorsCardRegister from "components/Registry/ContractorsCardRegister";
import VatRegister from "components/Registry/VatRegister";
import JpkRegister from "components/Registry/JpkRegister";
import BilanseRegister from "components/Registry/BilanseRegister";
import SettlementsRegister from "components/Registry/SettlementsRegister";

const RegistryModule = () => {
  const { t } = useTranslation();
  const { view } = useParams();
  const [searchText, setSearchText] = useState("");
  const [subtitle, setSubtitle] = useState(t("common.all"));
  const [debouncedText] = useDebounce(searchText, 300);

  const handleChangeSearchBar = (text: string) => setSearchText(text);

  const leftPanel = () => {
    if (view === "edelivery") {
      return (
        <MessagesRegister
          id="edelivery"
          kind={ItemKind.EDeliveryMessage}
          searchText={debouncedText}
          setSubtitle={setSubtitle}
        ></MessagesRegister>
      );
    }

    if (view === "courtportal") {
      return (
        <MessagesRegister
          id="court"
          kind={ItemKind.CourtPortalDeliverance}
          searchText={debouncedText}
          setSubtitle={setSubtitle}
        ></MessagesRegister>
      );
    }

    if (view === "nota") {
      return (
        <MessagesRegister
          id="nota"
          kind={ItemKind.ContactMessage}
          searchText={debouncedText}
          setSubtitle={setSubtitle}
        ></MessagesRegister>
      );
    }

    if (view === "cases") {
      return (
        <CasesRegister
          kind={ItemKind.CourtPortalDeliverance}
          searchText={debouncedText}
          setSubtitle={setSubtitle}
        ></CasesRegister>
      );
    }

    if (view === "ksef") {
      return (
        <DokumentyKsiegoweRegister
          searchText={debouncedText}
          setSubtitle={setSubtitle}
        />
      );
    }

    if (view === "contracts") {
      return (
        <ContractRegister
          searchText={debouncedText}
          setSubtitle={setSubtitle}
        />
      );
    }

    if (view === "pi") {
      return (
        <PIDeliverancesRegister
          searchText={debouncedText}
          setSubtitle={setSubtitle}
        />
      );
    }

    if (view === "zois") {
      return (
        <TrialBalanceRegister
          searchText={debouncedText}
          setSubtitle={setSubtitle}
        />
      );
    }

    if (view === "operacje-finansowe") {
      return (
        <DokumentyKsiegoweRegister
          searchText={debouncedText}
          setSubtitle={setSubtitle}
          initialDocType="bank:all"
        />
      );
    }

    if (view === "dziennik") {
      return (
        <JournalRegister
          searchText={debouncedText}
          setSubtitle={setSubtitle}
        />
      );
    }

    if (view === "rejestr-vat") {
      return (
        <VatRegister
          searchText={debouncedText}
          setSubtitle={setSubtitle}
        />
      );
    }

    if (view === "jpk") {
      return (
        <JpkRegister
          searchText={debouncedText}
          setSubtitle={setSubtitle}
        />
      );
    }

    if (view === "bilanse") {
      return (
        <BilanseRegister
          searchText={debouncedText}
          setSubtitle={setSubtitle}
        />
      );
    }

    if (view === "rozrachunki") {
      return (
        <SettlementsRegister
          searchText={debouncedText}
          setSubtitle={setSubtitle}
        />
      );
    }

    if (view === "kontrahenci") {
      return (
        <ContractorsRegister
          searchText={debouncedText}
          setSubtitle={setSubtitle}
        />
      );
    }

    if (view === "kartoteka-kontrahentow") {
      return (
        <ContractorsCardRegister
          searchText={debouncedText}
          setSubtitle={setSubtitle}
        />
      );
    }

    return <div>todo</div>;
  };

  const getLeftPanelTitle = () => {
    if (view === "edelivery") return t("registry.edelivery");
    if (view === "courtportal") return t("registry.courtPortal");
    if (view === "nota") return t("registry.encryptedPackages");
    if (view === "cases") return t("registry.folders");
    if (view === "contracts") return "Rejestr umów";
    if (view === "ksef") return "Dokumenty księgowe";
    if (view === "pi") return "Doręczenia PI";
    if (view === "zois") return "Zestawienie obrotów i sald";
    if (view === "operacje-finansowe") return "Dokumenty księgowe";
    if (view === "dziennik") return "Dziennik księgowań";
    if (view === "rozrachunki") return "Rozrachunki";
    if (view === "kontrahenci") return "Kontrahenci";
    if (view === "kartoteka-kontrahentow") return "Kartoteka kontrahentów";
    return t("registry.title");
  };

  const rightPanel = () => {
    return <EmptyPanel />;

    // return (
    //   <>
    //     <UserRightSide userId={userId} />
    //     {/* <ClientNew clientId={clientId} /> */}
    //   </>
    // );
  };

  return (
    <PanelsLayout
      title={getLeftPanelTitle()}
      subTitle={subtitle}
      onChangeSearch={handleChangeSearchBar}
      leftPanel={leftPanel()}
      hideRight={true}
      rightPanel={rightPanel()}
      isSearchExpanded={true}
    />
  );
};
export default RegistryModule;
